import React from 'react';

const selectClass = 'rounded-md border border-slate-700 bg-slate-950 px-2 py-1.5 text-xs text-slate-200';

const CustomerExperienceFilterBar = ({ filters, setFilters, areas = [], onRefresh }) => {
  const update = (key, value) => setFilters((prev) => ({ ...prev, [key]: value }));
  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-3">
      <div className="flex flex-wrap items-center gap-2">
        <select className={selectClass} value={filters.area || ''} onChange={(e) => update('area', e.target.value)}>
          <option value="">Semua Area</option>
          {(areas || []).map((area) => (
            <option key={`area-${area.areaName}`} value={area.areaName}>{area.areaName}</option>
          ))}
        </select>

        <select className={selectClass} value={filters.experienceLevel || ''} onChange={(e) => update('experienceLevel', e.target.value)}>
          <option value="">Semua Experience Level</option>
          <option value="GOOD">GOOD</option>
          <option value="WATCH">WATCH</option>
          <option value="DEGRADED">DEGRADED</option>
          <option value="CRITICAL">CRITICAL</option>
        </select>

        <select className={selectClass} value={filters.complaintRisk || ''} onChange={(e) => update('complaintRisk', e.target.value)}>
          <option value="">Semua Risiko Komplain</option>
          <option value="LOW">LOW</option>
          <option value="MEDIUM">MEDIUM</option>
          <option value="HIGH">HIGH</option>
          <option value="CRITICAL">CRITICAL</option>
        </select>

        <select className={selectClass} value={filters.churnRisk || ''} onChange={(e) => update('churnRisk', e.target.value)}>
          <option value="">Semua Risiko Churn</option>
          <option value="LOW">LOW</option>
          <option value="MEDIUM">MEDIUM</option>
          <option value="HIGH">HIGH</option>
          <option value="CRITICAL">CRITICAL</option>
        </select>

        <select className={selectClass} value={filters.outreachPriority || ''} onChange={(e) => update('outreachPriority', e.target.value)}>
          <option value="">Semua Prioritas Outreach</option>
          <option value="HIGH">HIGH</option>
          <option value="CRITICAL">CRITICAL</option>
        </select>

        <button
          type="button"
          className="rounded-md border border-slate-700 bg-slate-950 px-3 py-1.5 text-xs text-slate-200"
          onClick={() => setFilters({ area: '', experienceLevel: '', complaintRisk: '', churnRisk: '', outreachPriority: '' })}
        >
          Reset
        </button>

        <button
          type="button"
          className="rounded-md border border-cyan-500/40 bg-cyan-500/10 px-3 py-1.5 text-xs text-cyan-100"
          onClick={onRefresh}
        >
          Refresh
        </button>
      </div>
    </section>
  );
};

export default CustomerExperienceFilterBar;
